import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const PurchasePriceField = () => {
    const value = useWizardDemoStore((state) => state.applicationKeyItems.purchasePrice);
    const updateApplicationKeyItems = useWizardDemoStore((state) => state.updateApplicationKeyItems);

    return (
        <MoneyBox
            id='applicationPurchasePrice'
            value={value}
            onChange={(price) => updateApplicationKeyItems({ purchasePrice: price ?? undefined })}
            label='Purchase Price'
            required={true}
            width={'100%'}
            min={0}
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            height={'36px'}
            labelWidth='180px'
        />
    );
};
